const Button = (props: any) => {
    return  <div className={`teams-button ${props.extraBtnClass ?? ''}`}>
        <button
            className={`teams-button button ${props.btnClass ?? ''}`}
            onClick={(event) => props.onClick(event)}
        >
            {props.icon ?? ''} {props.buttonName}
        </button>
    </div>
}

export default Button;
